import { render, staticRenderFns } from "./SliderGallery.vue?vue&type=template&id=55abee12&scoped=true&"
import script from "./SliderGallery.vue?vue&type=script&lang=js&"
export * from "./SliderGallery.vue?vue&type=script&lang=js&"
import style0 from "./SliderGallery.vue?vue&type=style&index=0&id=55abee12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55abee12",
  null
  
)

export default component.exports